module.exports = __webpack_public_path__ + "static/Road2-ba37c0203711150f33b202c0c5fe7075.webm";